"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_2 = require("@nextui-org/react");
var clsx_1 = __importDefault(require("clsx"));
var react_router_dom_1 = require("react-router-dom");
function StepIndicator(_a) {
    var _b, _c;
    var title = _a.title, steps = _a.steps, _d = _a.allowStepClick, allowStepClick = _d === void 0 ? true : _d;
    var _e = (0, react_router_dom_1.useSearchParams)(), searchParams = _e[0], setSearchParams = _e[1];
    var stepFromUrl = parseInt(searchParams.get("step") || "1", 10);
    var _f = (0, react_1.useState)(stepFromUrl >= 1 && stepFromUrl <= steps.length ? stepFromUrl : 1), currentStep = _f[0], setCurrentStep = _f[1];
    (0, react_1.useEffect)(function () {
        var currentParam = searchParams.get("step");
        if (currentParam !== String(currentStep)) {
            setSearchParams({ step: String(currentStep) });
        }
    }, [currentStep, searchParams]);
    var goToStep = function (step) {
        if (step >= 1 && step <= steps.length) {
            setCurrentStep(step);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_2.Card, __assign({ className: "w-full" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4 p-4 " }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "text-2xl font-bold" }, { children: title })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "font-bold text-[#0A1D56]" }, { children: ["Step ", currentStep, ": ", (_b = steps[currentStep - 1]) === null || _b === void 0 ? void 0 : _b.label] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex items-center gap-2 overflow-x-auto" }, { children: steps.map(function (step, index) {
                        var stepNumber = index + 1;
                        var isActive = stepNumber === currentStep;
                        return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ role: "button", tabIndex: 0, onClick: function () { return allowStepClick && goToStep(stepNumber); }, onKeyDown: function (e) { return allowStepClick && e.key === "Enter" && goToStep(stepNumber); }, className: "flex flex-col items-center cursor-pointer" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ "aria-current": isActive ? "step" : undefined, className: (0, clsx_1.default)("w-10 h-10 flex items-center justify-center rounded-full shadow-sm", {
                                            "bg-[#0A1D56] text-white": isActive,
                                            "bg-gray-200 text-[#0A1D56]": !isActive,
                                        }) }, { children: stepNumber })) })), stepNumber < steps.length && (0, jsx_runtime_1.jsx)("div", { className: "w-10 bg-borders h-1" })] }, index));
                    }) })), (0, jsx_runtime_1.jsx)("div", { children: (_c = steps[currentStep - 1]) === null || _c === void 0 ? void 0 : _c.content({ goToStep: goToStep }) })] })) })));
}
exports.StepIndicator = StepIndicator;
